import { useState } from "react";
import { PlatformUsage, PostFieldLabel } from "components/Posts/PostForm";
import { FIELDS } from "constants/PostFormFields";
import PostFieldError from "components/Posts/PostForm/PostFieldError/PostFieldError";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import get from "lodash/get";
import type { AccountType } from "shared/types/accounts";
import type { PlatformSpec } from "constants/Platforms";
import type { FormValidationErrors, FormPlatformType } from "shared/types/post";

const ThreadsReplyControl = ({
  post,
  selectedPlatform,
  platforms,
  disabled = false,
  onChange,
  errors,
  className = "",
}: {
  post: any;
  disabled?: boolean;
  errors: FormValidationErrors | undefined;
  onChange: (value: string) => void;
  className?: string;
  platforms?: PlatformSpec[];
  selectedPlatform?: FormPlatformType;
  title?: string;
  selectedAccounts?: AccountType[];
}) => {
  // sometimes the post is a prop of the "post" passed in
  // (post.post) haven't checked why this is the case
  const thReplyValueInPost =
    post && get(post, FIELDS.TH_REPLY_CONTROL, undefined);
  const thReplyValueInPostPropertyOfPost =
    post && post.post && get(post.post, FIELDS.TH_REPLY_CONTROL, undefined);
  const thReplyValue =
    thReplyValueInPost || thReplyValueInPostPropertyOfPost || "everyone";
  const [selected, setSelected] = useState(thReplyValue);

  const replyControlOptions = [
    {
      value: "everyone",
      label: "Everyone",
    },
    {
      value: "accounts_you_follow",
      label: "Accounts you follow",
    },
    {
      value: "mentioned_only",
      label: "Mentioned only",
    },
  ];

  const handleSelectChange = (item: any) => {
    setSelected(item);
    onChange(item);
  };

  return (
    <div className={className}>
      <div className="flex items-center">
        <PostFieldLabel className="mb-2 mr-4">
          Threads reply control
        </PostFieldLabel>
        <PlatformUsage
          platforms={platforms}
          field={FIELDS.TH_REPLY_CONTROL}
          selectedPlatform={selectedPlatform}
        />
      </div>
      <Select
        value={selected}
        onValueChange={handleSelectChange}
        disabled={disabled}
      >
        <SelectTrigger>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {replyControlOptions.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <PostFieldError
        className="mt-4"
        fields={[FIELDS.TH_REPLY_CONTROL]}
        errors={errors}
      />
    </div>
  );
};

export default ThreadsReplyControl;
